/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Button_DefaultInputs */

const en_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const id_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salin`)
};

const ms_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salin`)
};

const ca_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia`)
};

const cs_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const da_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiér`)
};

const de_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieren`)
};

const et_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopeeri`)
};

const es_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar`)
};

const fr_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier`)
};

const hr_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiraj`)
};

const it_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia`)
};

const lv_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopēt`)
};

const lt_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopijuoti`)
};

const hu_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Másolás`)
};

const nl_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieer`)
};

const nb_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopier`)
};

const pl_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiuj`)
};

const pt_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar`)
};

const ro_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiază`)
};

const sk_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopírovat`)
};

const sl_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiraj`)
};

const fi_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopioi`)
};

const sv_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiera`)
};

const vi_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sao chép`)
};

const tr_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopyala`)
};

const el_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αντιγραφή`)
};

const bg_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копиране`)
};

const ru_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копировать`)
};

const sr_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копирај`)
};

const uk_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопіювати`)
};

const ka_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`კოპირება`)
};

const hi_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कॉपी बनाएं`)
};

const th_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คัดลอก`)
};

const ko_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`복사`)
};

const zh_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制`)
};

const zh_tw_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複製`)
};

const ja_copy_button_default = /** @type {(inputs: Copy_Button_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピー`)
};

/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Copy_Button_DefaultInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const copy_button_default = /** @type {((inputs?: Copy_Button_DefaultInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Button_DefaultInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_copy_button_default(inputs)
	if (locale === "ms") return ms_copy_button_default(inputs)
	if (locale === "ca") return ca_copy_button_default(inputs)
	if (locale === "cs") return cs_copy_button_default(inputs)
	if (locale === "da") return da_copy_button_default(inputs)
	if (locale === "de") return de_copy_button_default(inputs)
	if (locale === "et") return et_copy_button_default(inputs)
	if (locale === "es") return es_copy_button_default(inputs)
	if (locale === "fr") return fr_copy_button_default(inputs)
	if (locale === "hr") return hr_copy_button_default(inputs)
	if (locale === "it") return it_copy_button_default(inputs)
	if (locale === "lv") return lv_copy_button_default(inputs)
	if (locale === "lt") return lt_copy_button_default(inputs)
	if (locale === "hu") return hu_copy_button_default(inputs)
	if (locale === "nl") return nl_copy_button_default(inputs)
	if (locale === "nb") return nb_copy_button_default(inputs)
	if (locale === "pl") return pl_copy_button_default(inputs)
	if (locale === "pt") return pt_copy_button_default(inputs)
	if (locale === "ro") return ro_copy_button_default(inputs)
	if (locale === "sk") return sk_copy_button_default(inputs)
	if (locale === "sl") return sl_copy_button_default(inputs)
	if (locale === "fi") return fi_copy_button_default(inputs)
	if (locale === "sv") return sv_copy_button_default(inputs)
	if (locale === "vi") return vi_copy_button_default(inputs)
	if (locale === "tr") return tr_copy_button_default(inputs)
	if (locale === "el") return el_copy_button_default(inputs)
	if (locale === "bg") return bg_copy_button_default(inputs)
	if (locale === "ru") return ru_copy_button_default(inputs)
	if (locale === "sr") return sr_copy_button_default(inputs)
	if (locale === "uk") return uk_copy_button_default(inputs)
	if (locale === "ka") return ka_copy_button_default(inputs)
	if (locale === "hi") return hi_copy_button_default(inputs)
	if (locale === "th") return th_copy_button_default(inputs)
	if (locale === "ko") return ko_copy_button_default(inputs)
	if (locale === "zh") return zh_copy_button_default(inputs)
	if (locale === "zh-tw") return zh_tw_copy_button_default(inputs)
	if (locale === "ja") return ja_copy_button_default(inputs)
	return en_copy_button_default(inputs)
});